import { bankServices } from "../../config/axios";
import {
    BANKBRANCHLIST_SUCCESS,
    BANKBRANCHLIST_FAILED,
    RESET_BANKBRANCHLIST,
    LOADING_BANKBRANCHLIST,
    BANKBRANCHLIST_NETWORKERROR,
} from '../types/index';

const resetbankBranchList = () => {
    return { type: RESET_BANKBRANCHLIST };
};

const bankBranchList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BANKBRANCHLIST });
    await bankServices
        .post("bankmasterbranchlist", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: BANKBRANCHLIST_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: BANKBRANCHLIST_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: BANKBRANCHLIST_FAILED,
        payload: data
    };
}

export { resetbankBranchList, bankBranchList }